export default __webpack_public_path__ + "static/media/knock.10472090.mp4";